import { z } from 'zod';
import { zLookup, zYesno } from '@/utils/zodHelper';

export const FailModeSchema = z.object({
  id: z.number(),
  origin: zLookup(),
  cause: zLookup(),
  comment: z.string().optional(),
  status: zLookup().optional(),
});

export const FailModeFormSchema = z.object({
  theme: z.string().min(1, 'Campo obrigatório'),
  comment_general: z.string().min(1, 'Campo obrigatório'),
  actions: z
    .array(
      z.object({
        description: z.string().optional(),
        status: zLookup().optional(),
        due_date: z.date().optional().nullable(),
        area: z.string().optional().nullable(),
        responsible: z.string().optional(),
        implemented: zYesno().optional(),
        displayed: z.boolean().optional().nullable(),
        file: z.string().optional().nullable(),
        functional_area: zLookup().optional().nullable(),
      }),
    )
    .optional(),
});

export type FailModeFormType = z.infer<typeof FailModeFormSchema>;
export type FailModeSchemaType = z.infer<typeof FailModeSchema>;
